import React from 'react'
import { Box, Checkbox, Typography } from '@mui/material'

export function ColoredCheckbox({
  label,
  color,
  checked,
  onToggle,
}: {
  label: string
  color: string
  checked: boolean
  onToggle: () => void
}): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        userSelect: 'none',
      }}
      onClick={onToggle}
    >
      <Checkbox
        checked={checked}
        sx={{
          p: 0.5,
          color,
          '&.Mui-checked': { color },
        }}
      />
      <Typography variant="body2">{label}</Typography>
    </Box>
  )
}
